import React from 'react';

/**
 *
 * @param {string} icon ID of the icon
 * @param {string} label Used for aria-label for accessibility purposes.
 * @param {string} extraClass Extra class names as a string, no leading/trailing spaces needed.
 * @param {string} extraClassInner Extra class names as a string, no leading/trailing spaces needed.
 * @param {string } color see which colors that are available in icons.scss
 * @param {Function} onClick
 * @returns {JSX.Element}
 * @constructor
 */
export const Svg = function({icon, label, extraClass = '', extraClassInner = '', color = '', onClick = null}) {
    let elClass = `icon icon-${icon} ${extraClass}`.trim();

    if (color.length) {
        elClass += ` icon--${color}`;
    }

    return (
        <svg className={elClass} aria-label={label} role="img" aria-hidden="true" focusable="false" onClick={onClick}>
            <use xlinkHref={`#${icon}`} className={extraClassInner} />
        </svg>
    );
}

export default Svg;
